import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import Hosting from './pages/Hosting'; // Import the Hosting page
import ResponsiveNavbar from './components/Nav';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/common/ScrollToTop';
import AllProductsPage from './pages/AllProductsPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
        <Header />
        <ResponsiveNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hosting" element={<Hosting />} /> {/* Hosting Page Route */}
          <Route path="/store" element={<AllProductsPage />} /> {/* All Products Page Route */}
          <Route path="/*" element={<NotFound />} /> {/* Catch-all for 404 */}
        </Routes>
        <Footer />
   
    </Router>
  );
}

export default App;
